module.exports = __webpack_public_path__ + "media/images/favicon/apple-touch-icon-76x76-379291814b918f17ad2f023c9a0e06bc.png";